import { SYSBaseElement, SYSConfig, html } from "../../../../_ovlclient/src"
import {
  ScreenCurrentState,
  ScreenNavigateBack,
} from "../../../../_ovlclient/src/library/screenapi"
import { T } from "../../../../_ovlclient/src/textapi"

export class CompSYSBackButton extends SYSBaseElement {
  async getUI() {
    const handleBack = (e: Event) => {
      ScreenNavigateBack()
    }
    let currentScreenState = ScreenCurrentState()
    if (
      SYSConfig.app.screens?.[currentScreenState?.screen]?.noHistory !== true &&
      this.state.ovl.screens.nav.screensHistory.filter(
        (f) =>
          !(
            f.screen === currentScreenState.screen &&
            f.instance === currentScreenState.instance
          )
      ).length > 0
    ) {
      return html`
        <button
          @click=${handleBack}
          class="fd-button fd-shellbar__button fd-has-type-4 fd-has-color-action-2 ovl_zindex_2"
          aria-label=""
          title=${T("SYSNavigateBack")}
          id="SYSNavigateBack"
        >
          <span
            class="sap-icon--sys-back ovl-backbuttonicon fd-has-color-action-2"
          ></span>
        </button>
      `
    } else {
      return null
    }
  }
}
